/* eslint-disable */
import React from "react";
import { useParams } from "react-router-dom";

import { useEffect, useState } from "react";
import {
  fetchIncidentsDangerPauseApp,
  fetchIncidentGet,
  fetchIncidentsTimeline,
  fetchOrganisationsTransferPost,
} from "../../../services/api-raindrop";
import RaindropLoadingElement from "../../../ui-components/raindrop-loading-element/raindrop-loading-element";

import RaindropScrollContainer from "../../../ui-components/raindrop-scroll-container/raindrop-scroll-container.tsx";

import NimbusTimelineItem from "../../../ui-components/nimbus-timeline-item/nimbus-timeline-item";
import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import ModelTag from "../../../ui-components/model-tag/model-tag";
import ModelComponentIncident from "../../../ui-components/model-component-incident/model-component-incident";
import RaindropDivider from "../../../ui-components/raindrop-divider/raindrop-divider";
import ModelComponentIncidentStatus from "../../../ui-components/model-component-incident-status/model-component-incident-status";

const IncidentTimelineFilter = ({ ignoreTypes, toggleType }) => {
  return (
    <div className="flex flex-row gap-2 p-2 flex-wrap">
      <ModelTag
        modelId="note__"
        isShowingIcon={false}
        isOutline={ignoreTypes.includes("ORGANISATION_TRANSFER")}
        onClick={() => toggleType("ORGANISATION_TRANSFER")}
      />
    </div>
  );
};

const IncidentTimeline = ({ incidentId }) => {
  const [timeline, setTimeline] = useState(null);
  const [ignoreTypes, setIgnoreTypes] = useState([]);

  useEffect(() => {
    fetchIncidentsTimeline({ incidentId }).then((timeline) => {
      setTimeline(timeline);
    });
  }, [incidentId]);

  const toggleType = (type) => {
    if (ignoreTypes.includes(type)) {
      setIgnoreTypes(ignoreTypes.filter((t) => t !== type));
    } else {
      setIgnoreTypes([...ignoreTypes, type]);
    }
  };

  console.log("🟢 (RD-783) - ", timeline);
  return (
    <div className="flex flex-col h-full gap-3">
      <div className={`flex flex-row gap-3 font-bold text-3xl w-full`}>
        Timeline
      </div>
      <div className="text-sm text-color-dark-text-secondary">
        This is the organisation timeline. It shows the events relevant to the
        organisation. Use the filters to find what you're after.
      </div>
      <IncidentTimelineFilter
        ignoreTypes={ignoreTypes}
        toggleType={toggleType}
      />

      <RaindropScrollContainer>
        {timeline &&
          timeline.items
            .filter((item) => !ignoreTypes.includes(item.type))
            .map((timelineItem) => {
              console.log("🟢 (RD-215) - ", timelineItem);
              return (
                <NimbusTimelineItem
                  type={timelineItem.type}
                  date={timelineItem.date}
                  data={timelineItem.data}
                />
              );
            })}
      </RaindropScrollContainer>
    </div>
  );
};

const IncidentHeading = () => {
  return (
    <div className="flex flex-row items-center gap-4">
      <i className="fa fa-poo-storm text-6xl" />
      <div className="flex flex-col gap-1">
        <div className="text-2xl font-bold">Unnamed Incident</div>
        <div className="text-sm text-color-dark-text-secondary">
          Declared in June 2024 by Rhaz
        </div>
      </div>
    </div>
  );
};

const DangerousIncidentActions = ({ incidentId }) => {
  const onPauseApp = () => {
    fetchIncidentsDangerPauseApp({ incidentId }).then((data) => {
      console.log("🟢 (RD-037) - ", data);
    });
  };

  const onPauseCronJobs = () => {};
  return (
    <div className="flex flex-col w-full gap-4">
      <div className="flex flex-col gap-2">
        <div className="flex flex-row gap-2 items-center text-2xl font-bold">
          <i className="fa fa-exclamation-triangle text-color-status-bad" />
          <div>Danger</div>
        </div>
        <div className="text-sm text-color-dark-text-secondary">
          The following actions are extremely powerful and can affect the
          reputation of The Raindrop Company. Use with caution.
        </div>
      </div>

      <div
        className={`flex flex-col gap-4 border p-4 rounded-lg
      dark:border-color-status-bad border-color-status-bad
      `}
      >
        <div id="danger-action-block-access" className="flex flex-col gap-2">
          <div className="font-bold">Block Access to Raindrop</div>
          <div className="text-sm text-color-dark-text-secondary">
            Block access to all users of Raindrop. The app will show a loading
            screen saying we are under maintenance.
          </div>
          <RaindropButton
            title="Block Access"
            onClick={onPauseApp}
            isDangerous={true}
            icon="fa-ban"
          />
        </div>
        <RaindropDivider />
        <div id="danger-action-pause-cron" className="flex flex-col gap-2">
          <div className="font-bold">Pause all cron jobs</div>
          <div className="text-sm text-color-dark-text-secondary">
            Pauses all cron jobs. This stops sweeping bank accounts for payments
            and stops distributing payments. Cron jobs will remain in the queue
            and will be executed when unpaused. All cron jobs are idempotent.
          </div>
          <RaindropButton
            title="Pause Cron Jobs"
            onClick={onPauseCronJobs}
            isDangerous={true}
            icon="fa-pause"
          />
        </div>
      </div>
    </div>
  );
};
const NimbusIncidentsInstance = () => {
  const { incidentId } = useParams();
  const [incident, setIncident] = useState(null);

  useEffect(() => {
    fetchIncidentGet({ incidentId }).then((incident) => {
      console.log("🟢 (RD-037) - ", incident);
      setIncident(incident);
    });
  }, [incidentId]);

  if (incident === null) {
    return <RaindropLoadingElement />;
  }

  console.log("🟢 (RD-677) - ", incident);

  return (
    <div className="flex flex-row justify-around h-full w-full ">
      <div className="flex flex-col w-full max-w-md gap-6">
        <IncidentHeading />
        <div>
          <RaindropButton
            title="Google Meet"
            to="https://meet.google.com/jav-ojrt-thq"
            icon="fa-video"
            style={ButtonStyle.Secondary}
          />
        </div>
        <RaindropScrollContainer additionalClassNames="gap-4">
          <ModelComponentIncident
            incidentId={incident.id}
            title={incident.title}
            createdAt={incident.createdAt}
            declaredById={incident.declared_by.id}
            declaredByName={incident.declared_by.name_preferred}
          />
          <ModelComponentIncidentStatus
            id={incident.latest_status.id}
            status={incident.latest_status.status}
          />
          <DangerousIncidentActions incidentId={incident.id} />
        </RaindropScrollContainer>
      </div>
      <div className="w-full max-w-md">
        <IncidentTimeline incidentId={incident.id} />
      </div>
    </div>
  );
};

export default NimbusIncidentsInstance;
